(function () {
    'use strict';

    angular.module('thankview.videoRequest', ['thankview.global', 'thankview.recorder', 'thankview.video'])
        .controller('VideoRequestController', ['$scope', '$rootScope', '$q', 'ajax', 'recorderService', '$window', '$document', '$timeout', 'mediaServerService', 'vidJs', function ($scope, $rootScope, $q, ajax, recorderService, $window, $document, $timeout, mediaServerService, vidJs) {
            var isPreview;
            const instructionBox = $document[0].querySelector('.tv-rich-text-content');
            let isLanding;
            var videoId = 'video-request-example';
            var startOffset;

            if (config.params.vr_example_video) {
                $scope.video = config.params.vr_example_video;
                $scope.video.video_thumb = config.params.vr_example_video_thumb;
            }

            // options object to provide to the recorder module
            $scope.recorderOptions = {
                showTipsButton: false,
                showInstructionsButton: true,
                showStartOverButton: true,
            };

            $scope.$on('request-form-submitted', function ($event, guestInfo) {
                $scope.postVideo(guestInfo);
            });

            $scope.init = function () {
                var pathNames = $window.location.pathname.split('/');
                isPreview = pathNames[2] && pathNames[2] === 'preview';
                isLanding = pathNames[2] && pathNames[2] === 'landing';


                $scope.initReply();

                // bind on recorder state
                recorderService.onStateChange($scope.stateChange);

                $scope.fetchTranslations();

                $scope.loadFS();

                $scope.setMediaServer();

                // instruction box is only present when submissions are open (public campaign)
                // or if the campaign was sent to specific recipients
                // ensure the box was found before attempting to check if its content fits
                if (instructionBox) {
                    $timeout(() => {
                        $scope.checkInstructionLength();
                    }, 1000);

                    angular.element($window).on('resize', () => {
                        $scope.checkInstructionLength();
                    });
                }


                // if this is a landing preview, we want to remove a loading indicator
                if (isLanding) {
                    const path = 'https://' + $window.location.hostname;
                    $window.parent.postMessage('landing-loaded', path);

                    // define preview update function
                    $window.updateRequestFor = function (recipient) {
                        var reqFor = $document[0].getElementById('request-for-name');
                        // video requests currently always use naming option 0 (first name + last name)
                        // TODO: support multiple naming options
                        if (reqFor) {
                            reqFor.innerHTML = recipient.name + ' ' + recipient.last_name;
                        }
                    };
                    // allow parent frame to update project description
                    $window.updateProjectDesc = function (projectDesc) {
                        var projectDescEl = $document[0].getElementById('cta-message-container');
                        if (projectDescEl) {
                            projectDescEl.innerHTML = projectDesc;
                        }
                    };
                }

                if (isPreview) {
                    $scope.closePreviewNotice = function ($event) {
                        $event.target.parentElement.style.display = 'none';
                    };
                }
                angular.element($window).on('beforeunload', $scope.checkForVideo);
                if (config.params.vr_example_video) {
                    $scope.loadVideo();
                }
            };


            $scope.loadVideo = function () {
                const video = $scope.video;
                let params = {};

                if (video.title) {
                    $scope.title = video.title;
                }

                $scope.$broadcast('open-overlay');

                startOffset = 0;

                if (!video.final_video && video.start_trim) {
                    startOffset += video.start_trim;
                    if (video.time_diff) {
                        startOffset += video.time_diff;
                    }
                }

                var videoUrl;
                if (video.final_video) {
                    videoUrl = video.final_video;
                } else {
                    videoUrl = video.video_path;
                }

                var videoElement = $document[0].querySelector('#' + videoId + '-wrapper');

                var options = {
                    image: video.video_thumb,
                    skin: {
                        name: 'thankview',
                    },
                    muted: false,
                    autoplayCaptions: true,
                    captions: video.video_caption,
                };

                vidJs.init(videoId, videoUrl, videoElement, options);

                // display error if video is unplayable
                vidJs.onError(function () {
                    var error = vidJs.getError();

                    if (error.code === 3 || error.code === 4) {
                        $scope.$broadcast('force-close-overlay');
                        params = {
                            header: 'This video can\'t be previewed',
                        };
                        $rootScope.$broadcast('open-message', 'The video is being converted to play in a browser. Please try again in a few minutes.', params);
                    } else if ($window.Bugsnag) {
                        Bugsnag.notify(new Error('Video JS Error ' + error.message));
                    }
                });

                vidJs.onReady(function () {
                    vidJs.seek(startOffset);
                    // vidJs.play();
                });

                vidJs.onFirstFrame(function () {
                    if (startOffset > 0) {
                        vidJs.seek(startOffset);
                    }
                });

                vidJs.onTime(function (time) {
                    if (time.position < startOffset) {
                        vidJs.seek(startOffset + 0.01);
                    }

                    if (video.end_trim) {
                        if (time.position >= video.end_trim - 0.01 && !video.final_video && time.position < time.duration) {
                            vidJs.resetVideo();
                        }
                    }
                });

                $scope.downloadUrl = undefined;

                if (!params || !params.hideDownload) {
                    if (video.final_video) {
                        $scope.downloadUrl = video.final_video;
                    } else if (!video.time_diff) {
                        $scope.downloadUrl = video.video_path;
                    }
                }

                $scope.video = video;
                if (params && params.crop_option) {
                    $scope.crop_option = params.crop_option;
                } else {
                    $scope.crop_option = null;
                }

                $scope.rerecordCallback = params ? params.rerecordCallback : undefined;
            };

            $scope.fetchTranslations = function () {
                var locale = $window.config.locale;
                var business = config.params.business;

                var params = {
                    filename: 'video_request',
                };

                if (business) {
                    params.replacements = {
                        businessName: business.full_name,
                        privacyPolicyUrl: business.privacy_policy,
                    };
                }

                ajax.post('/api/translate/' + locale, params).then(function (data) {
                    $scope.trans = data.trans;
                });
            };

            $scope.initReply = function () {
                // first, check if there's already an assigned video id
                // this tells us if the request is public or from a specific email
                const videoID = $document[0].querySelector('.video-request').getAttribute('data-video');
                if (videoID) {
                    $scope.isPublic = false;
                } else {
                    $scope.isPublic = true;
                }
                // next, setup the reply object and state variables
                $scope.reply = {
                    agree: false,
                    video_id: videoID,
                };
                $scope.howToOpen = false; // if the how-to record section is open or not
                $scope.recording = null;
                $scope.overlayInstructions = false; // if the instruction overlay is open or not
                $scope.submittedSuccessfully = false; // if the video was successfully submitted
                $scope.setSidebarState(null, true); // open the sidebar
            };

            // check if instructions overflow and we should show the expand button
            $scope.checkInstructionLength = function () {
                $scope.instructionsLong = instructionBox.scrollHeight > instructionBox.clientHeight;
            };

            $scope.expandInstructions = function () {
                angular.element(instructionBox).toggleClass('expanded');
            };

            $scope.setSidebarState = function ($event, open) {
                if ($event) $event.preventDefault();
                $scope.sidebarOpen = open;
                // trigger resize event for the recorder
                try {
                    $window.dispatchEvent(new $window.Event('resize'));
                } catch (e) {
                    // This IE workaround must be kept, as the video landing page should still support IE 11
                    // IE 11 cannot use resize event, so we do this:
                    var evt = $document[0].createEvent('UIEvents');
                    evt.initUIEvent('resize', true, false, $window, 0);
                    $window.dispatchEvent(evt);
                }

                // leverage existing functionality that prevents body scrolling for fullscreen nav on mobile
                // for video requests (on mobile) the sidebar is the closest thing the user has to navigation
                if (open) {
                    angular.element($document[0].body).addClass('nav-open');
                } else {
                    angular.element($document[0].body).removeClass('nav-open');
                }
            };

            $scope.recordTips = function ($event) {
                if ($event) $event.preventDefault();

                // if we're on a small display, sidebar is covering the player
                // close the sidebar so the video is visible
                if ($window.innerWidth <= 725) {
                    $scope.setSidebarState(null, false);
                }
                $rootScope.$broadcast('play-recording-tips');
            };

            $scope.stateChange = function (state) {
                $scope.state = state;

                if ($scope.state === 'uploadComplete') $scope.saveVideo();
                $scope.webcamActive = recorderService.getWebcamActive();
            };

            $scope.fadeOutContainer = function () {
                var deferred = $q.defer();

                if ($scope.fadeRecorderContainer) {
                    deferred.reject();
                    return deferred.promise;
                }

                $scope.fadeRecorderContainer = true;

                $timeout(function () {
                    deferred.resolve();

                    $scope.fadeRecorderContainer = false;
                    $scope.$apply();
                }, 400);

                return deferred.promise;
            };

            $scope.recorderReset = function () {
                recorderService.reset();
            };

            $scope.deactivateWebcam = function () {
                $scope.fadeOutContainer().then(function () {
                    recorderService.setState('waiting');
                    $scope.overlayInstructions = false;

                    $timeout(function () {
                        $scope.recorderReset();
                    }, 100);
                });
            };

            $scope.initWebcamRecorder = function () {
                if (isPreview) {
                    $rootScope.$broadcast('open-message', $scope.trans['submit-preview-disallowed']);
                } else {
                    recorderService.webcam.open();
                }
            };

            $scope.openUploadVideo = function () {
                if (isPreview) {
                    $rootScope.$broadcast('open-message', $scope.trans['submit-preview-disallowed']);
                } else {
                    recorderService.fileUploader.open();
                }
            };

            $scope.rerecord = function () {
                var deferred = $q.defer();

                deferred.promise.then(function () {
                    $scope.recording = null;

                    recorderService.reset();
                });

                $rootScope.$broadcast('open-message-confirm', $scope.trans['rerecord-warning'], deferred);
            };

            $scope.reUpload = function () {
                recorderService.fileUploader.reUpload();
            };

            $scope.saveVideo = function () {
                $scope.recording = recorderService.getRecording();

                recorderService.review.load($scope.recording);
            };

            $scope.submitVideo = function () {
                if ($scope.loading) return;

                if (isPreview) {
                    $rootScope.$broadcast('open-message', $scope.trans['submit-preview-disallowed']);
                    return;
                }

                if (!$scope.recording) {
                    $rootScope.$broadcast('open-message', $scope.trans['submit-warning']);
                    return;
                }

                var agreeMessage = $scope.trans['submit-policy-tv'];

                var business = config.params.business;
                if (business.privacy_policy) {
                    agreeMessage = $scope.trans['submit-policy-bz'];
                }

                // open video request submission form
                $rootScope.$broadcast('open-overlay-request-submit', agreeMessage);
            };

            $scope.postVideo = function (guestInfo = null) {
                var params = {
                    reply: angular.copy($scope.reply),
                    recording: angular.copy($scope.recording),
                    recipient_name: guestInfo.recipient_name,
                };

                // determine if we're submitting a public request, or specific request
                let endpoint = '/api/reply';
                if ($scope.isPublic) {
                    endpoint += '/public';
                    params.project_id = $document[0].querySelector('.video-request').getAttribute('data-project');
                    params.name = guestInfo.name;
                    params.email = guestInfo.email;
                    params.email = validatePhone(params.email) ? formatPhone(params.email) : params.email;
                    params.reply.agree = true;
                }

                $scope.loading = true;

                ajax.post(endpoint, params).then(function () {
                    $scope.loading = false;
                    $scope.sidebarOpen = false;
                    $scope.submittedSuccessfully = true;
                    const againDeferred = $q.defer();
                    const successParams = {
                        header: $scope.trans['submit-success-header'],
                        buttons: [
                            { name: $scope.trans.again, colorClass: 'btn--primary', callback: againDeferred.resolve() },
                        ],
                    };
                    $rootScope.$broadcast('open-message-confirm', $scope.trans['submit-success'], againDeferred, successParams);

                    // reset the state if they want to submit again
                    againDeferred.promise.then(() => {
                        $scope.submittingAgain = true;
                        $scope.initReply();
                        recorderService.reset();
                    });

                    if (typeof gtag === 'function') {
                        gtag('event', 'video request', { desc: 'submit video' });
                    }
                }).catch(function () {
                    $scope.loading = false;
                });
            };

            /**
             * Initialize full story service
             */
            $scope.loadFS = function () {
                if (config.env !== 'production') {
                    return;
                }

                if (!$window.FS) {
                    $timeout(function () {
                        $scope.loadFS();
                    }, 100);
                    return;
                }

                if (config.user) {
                    FS.identify(config.user.id, {
                        displayName: config.user.name,
                        email: config.user.email,
                    });
                } else {
                    FS.setUserVars({
                        displayName: config.params.recipientName,
                        email: config.params.recipientEmail,
                    });
                }
            };

            $scope.setMediaServer = function () {
                if (config.env !== 'production') {
                    return;
                }

                mediaServerService.getMediaServer().then((server) => {
                    config.mediaUrl = server;
                });
            };

            // Event Listeners
            $scope.$on('toggleInstructionOverlay', (event, forceClose) => {
                if (forceClose) {
                    $scope.overlayInstructions = false;
                } else {
                    $scope.overlayInstructions = !$scope.overlayInstructions;
                }
            });

            $scope.checkForVideo = function (e) {
                if ($scope.recording) {
                    var message = 'You have not submitted your video.';
                    e = e || $window.event;
                    if (e) {
                        e.returnValue = message;
                    }
                    return message;
                }
                return false;
            };

            $scope.init();
        }]);
}());
